module.exports = __webpack_public_path__ + "img/workshops_T.91f7c5cf.png";